let RouterAdditionalLinks = [];
// Demo: {name:config.name, path:config.path, icon: config.icon, order:config.order }
export {RouterAdditionalLinks};